import React from 'react';
import { observer } from "mobx-react";
import LoaderV1 from 'ReactApp/Components/LoaderV1/LoaderV1';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartProblemLoadV1Props = {
    showableCart: ShowableCart
}

const CartProblemLoadV1 = observer((props: CartProblemLoadV1Props) => {

    function getLastPhrase(): React.JSX.Element
    {
        if (props.showableCart.retries > 0) {
            return (
                <>
                    &nbsp;и постараемся загрузить их еще раз
                    <br/><strong style={{
                        fontSize: '2.5rem'
                    }}> через: {props.showableCart.anotherAttemptVia}</strong>
                </>
            );
        } else {
            return (
                <>
                    , <strong>попробуйте перезагрузить страницу вручную.</strong>
                </>
            );
        }
    }

    if (props.showableCart.anotherAttemptVia === null && props.showableCart.retries > 0) {
        return (
            <LoaderV1 />
        );
    } else {
        return (
            <div 
                className="
                    info-block-v1 
                    box-v1 
                    box-v1_filling-type-contained 
                    box-v1_filling-color-type-gray 
                    info-block-v1_text-color-type-text
                "
                style={{
                    marginBottom: '3rem'
                }}
                >
                    <div className="info-block-v1__content">
                        <h1 className="title js-catalog-title">
                            УПС!
                        </h1>
                        <p className="p-v1 p-v1_text-color-type-text" style={{
                            lineHeight: '3rem'
                        }}>
                            Кажется у нас небольшие технические проблемы,
                            <strong> но не переживайте, мы помним 
                                все Ваши выбранные товары а также заполненные данные
                            </strong>
                            { getLastPhrase() }
                        </p>
                    </div>
            </div>
        );
    }

})

export default CartProblemLoadV1;